function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.629.73v11.613c0 .428-.31.616-.709.462-.591-.23-1.468-.496-2.29-.464-2.11.082-3.822 1.712-3.822 3.823 0 2.111 1.711 3.823 3.823 3.823.6 0 1.164-.142 1.67-.388C9.564 18.182 9.483 15.6 9.483 15.6V3.923c0-.427.346-.752.773-.725l6.133.387c.427.026.772.395.772.823v6.838c0 .428-.314.718-.703.649l-.703-.126c-.041-.01-.083-.015-.124-.022l-.067-.012c-.172-.025-.347-.043-.527-.043-1.88 0-3.403 1.523-3.403 3.403 0 1.88 1.523 3.404 3.403 3.404.56 0 1.086-.136 1.551-.375.38-.196.936-.62 1.243-.917.531-.515.852-1.081 1.04-1.516.17-.393.242-1.081.242-1.509V1.407c0-.427-.346-.794-.773-.82L8.402.001c-.427-.025-.773.302-.773.729z"
});

var SvgMusic = function SvgMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/music.131fe7e6.svg";
export { ForwardRef as ReactComponent };